<template>
  <v-text-field
    v-model="internalValue"
    class="domain-search"
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled || loading"
    color="primary"
    flat
    solo
    clearable
    hide-details
    outlined
    background-color="#fff"
    prepend-inner-icon="ph-magnifying-glass"
    @input="handleInput"
  >
  </v-text-field>
</template>

<script>
export default {
  name: "DomainSearchInput",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: "Pesquisar domínio" },
    placeholder: { type: String, default: "Pesquisar domínio" },
    debounceMs: { type: Number, default: 600 },
  },
  data() {
    return {
      internalValue: this.value,
      debounceId: null,
    };
  },
  watch: {
    value(newVal) {
      if (newVal !== this.internalValue) {
        this.internalValue = newVal;
      }
    },
  },
  methods: {
    handleInput(val) {
      this.internalValue = val;
      if (this.debounceId) {
        clearTimeout(this.debounceId);
      }
      this.debounceId = setTimeout(() => {
        const normalized =
          typeof val === "string" ? val.trim() : val == null ? "" : String(val);
        this.$emit("input", normalized);
        this.$emit("input-search", normalized);
      }, this.debounceMs);
    },
  },
};
</script>

<style scoped>
.domain-search {
  max-width: 30%;
}

.domain-search >>> .v-input__slot {
  min-height: 46px;
  height: 46px;
  border-radius: 12px;
  box-shadow: none;
  background-color: #ffffff !important;
}

.domain-search >>> .v-input__slot::before,
.domain-search >>> .v-input__slot::after {
  display: none;
}

.domain-search >>> .v-text-field__details {
  display: none;
}
</style>
